"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const swiper_1 = require("./swiper");
const data_1 = require("./data");
const render_1 = require("./render");
const report_1 = require("./report");
require("./style/index.scss");
async function init() {
    const data = await data_1.initData();
    // console.log('data: ', data);
    const reporter = report_1.initReport();
    const container = render_1.renderPages(data);
    const swiper = swiper_1.initSwiper(container);
}
init();
